import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {ProductService} from '../../../Services/product.service';
import {ModelService} from '../../../Services/model.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-archive-stock-product',
  templateUrl: './archive-stock-product.component.html',
  styleUrls: ['./archive-stock-product.component.scss']
})
export class ArchiveStockProductComponent implements OnInit {
  public grid: Grid;
  public productId: any;
  public productName: string;
  @ViewChild('readdModal', {static: false}) readdModal;

  constructor(
    private router: Router,
    private productService: ProductService,
    private broadCastService: BroadcastService,
    private translate: TranslateService,
    private modelService: ModelService
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.product.inventory.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.model.model',
          prop: 'models',
          type: TextColumn.type,
          translate: true,
          sortable: false,
          valueFormatter: row => {
            const items = [];
            row.forEach(item => {
              items.push(item.name);
            });
            return items.join(',');
          },
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.product.inventory.article_number',
          prop: 'number',
          type: TextColumn.type,
          sortable: false,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.product.inventory.sku_or_ean_code',
          prop: 'EANCode',
          type: TextColumn.type,
          sortable: false,
          translate: true,

        },
        <TextColumn>{
          name: 'doctrine.product.inventory.tms_stock',
          prop: 'tmsStock',
          type: TextColumn.type,
          sortable: false,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.product.inventory.current_in_order',
          prop: 'currentInOrder',
          type: TextColumn.type,
          sortable: false,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.product.inventory.free_stock',
          prop: 'stock',
          type: TextColumn.type,
          sortable: false,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.product.inventory.low_stock',
          prop: 'lowStockTrigger',
          type: TextColumn.type,
          sortable: false,
          translate: true,
          width: 200,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-plus fa-lg',
              tooltip: 'global.readd',
              onclick: row => {
                this.productId = row.id;
                this.productName = row.name.bold();
                this.readdModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.productService,
      rememberURL: this.router.url,
      method: 'getStockProduct',
      defaultSort: 'position',
      archive: true,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'model_id',
          type: 'ng-select',
          label: 'doctrine.attributes.model',
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          value: new ServiceSearchItem(this.modelService, 'getModelsOfStockProducts', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            options.push({value: 'all', label: this.translate.instant('global.all')});
            for (const row of res.data) {
              options.push({value: row.id, label: row.name});
            }
            return options;
          })
        }
      ],
    };
  }

  goToInventoryOverview() {
    this.router.navigateByUrl('back-office/product/stock/overview');
  }

  readd() {
    this.productService.readdProduct(this.productId).subscribe((res) => {
      this.broadCastService.broadcast('refreshGrid', 'getStockProduct');
      this.readdModal.hide();
    });
  }
}
